import React, { Component } from "react";
import { Swiper, SwiperSlide } from "swiper/react/swiper-react";
import SwiperCore, { Autoplay } from "swiper";
// 导入css动画效果
import CSSTrans from "@/components/CSSTrans";
import "@/assets/styles/animates.scss";
SwiperCore.use([Autoplay]);
class About extends Component {
  state = {
    mySwiper_about: null,
    allowSlidePrev: false, // swiper 向上
    allowSlideNext: true, // swiper 向下
    about_1_show: false,
    about_2_show: false,
    about_3_show: false,
    about_4_show: false,
    autoplay_delay: 6000,
  };
  componentDidMount() {
    this.props.componentRef(this, "about");
  }
  slideChange = (e) => {
    // console.log("about:" + e.realIndex);
    switch (e.realIndex) {
      case 0:
        this.setState({
          about_1_show: true,
          about_2_show: false,
        });
        break;
      case 1:
        this.setState({
          about_1_show: false,
          about_2_show: true,
          about_3_show: false,
        });
        break;
      case 2:
        this.setState({
          about_2_show: false,
          about_3_show: true,
          about_4_show: false,
        });
        break;
      default:
        this.setState({
          about_3_show: false,
          about_4_show: true,
        });
        break;
    }
    if (e.realIndex === 0) {
      this.setState({
        allowSlidePrev: false,
        allowSlideNext: true,
      });
    } else if (e.realIndex === 3) {
      this.setState({
        allowSlidePrev: true,
        allowSlideNext: false,
      });
    } else {
      this.setState({
        allowSlidePrev: true,
        allowSlideNext: true,
      });
    }
  };
  setSwiper_about = (el) => {
    this.setState({
      mySwiper_about: el,
    });
  };
  render() {
    const { allowSlidePrev, allowSlideNext, autoplay_delay } = this.state;
    const about_content = JSON.parse(this.props.about_content);
    const about_2_list = JSON.parse(this.props.about_2_list);
    const about_3_list = JSON.parse(this.props.about_3_list);
    const logo_list = Array.from({ length: 14 }).map(
      (el, index) => `about_4_${index}.png`
    );
    return (
      <Swiper
        className="mySwiper_about"
        onSwiper={this.setSwiper_about}
        onSlideChange={this.slideChange}
        allowSlidePrev={allowSlidePrev}
        allowSlideNext={allowSlideNext}
        autoplay={{
          delay: autoplay_delay,
          pauseOnMouseEnter: true,
          disableOnInteraction: false,
        }}
        // loop={mySwiper_about_loop}
        initialSlide={0}
        navigation={{
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        }}
        speed={0}
        keyboard={true}
        pagination={{
          clickable: true,
        }}
        style={{
          "--swiper-pagination-bullet-width": "8px",
          "--swiper-pagination-bullet-height": "8px",
          "--swiper-pagination-color": "#5ab5f0",
          "--swiper-pagination-bullet-inactive-color": "none",
          "--swiper-pagination-bullet-inactive-opacity": ".8",
          "--swiper-navigation-color": "#5ab5f0",
        }}
      >
        <SwiperSlide>
          <div className="about_1">
            {CSSTrans(
              this.state.about_1_show,
              "fadeInUp_trans",
              <h1 className="title">{about_content[0].title}</h1>
            )}
            {CSSTrans(
              this.state.about_1_show,
              "fadeInUp_trans",
              <div className="content">{about_content[0].content}</div>
            )}
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="about_1 about_2">
            {CSSTrans(
              this.state.about_2_show,
              "fadeInUp_trans",
              <h1 className="title">{about_content[1].title}</h1>
            )}
            {CSSTrans(
              this.state.about_2_show,
              "fadeInUp_trans",
              <div className="content">{about_content[1].content}</div>
            )}
            <div className="content_member">
              {about_2_list.map((val, index) => (
                <div className="about_list" key={index}>
                  <div className="about_img about_2_img">
                    {CSSTrans(
                      this.state.about_2_show,
                      "fadeInUp_trans",
                      <img
                        src={require("@/assets/images/" + val.imgName).default}
                        alt=""
                      />
                    )}
                  </div>
                  {CSSTrans(
                    this.state.about_2_show,
                    "fadeInUp_trans",
                    <div className="about_title">{val.title}</div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="about_1 about_2 about_3">
            {CSSTrans(
              this.state.about_3_show,
              "fadeInUp_trans",
              <h1 className="title">{about_content[2].title}</h1>
            )}
            {CSSTrans(
              this.state.about_3_show,
              "fadeInUp_trans",
              <div className="content">{about_content[2].content}</div>
            )}
            <div className="content_member">
              {about_3_list.map((val, index) => (
                <div className="about_list" key={index}>
                  <div className="about_img about_3_img">
                    {CSSTrans(
                      this.state.about_3_show,
                      "fadeInUp_trans",
                      <img
                        src={require("@/assets/images/" + val.imgName).default}
                        alt=""
                      />
                    )}
                  </div>
                  {CSSTrans(
                    this.state.about_3_show,
                    "fadeInUp_trans",
                    <div className="about_title">{val.title}</div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="about_1 about_2 about_4">
            {CSSTrans(
              this.state.about_4_show,
              "fadeInUp_trans",
              <h1 className="title">{about_content[3].title}</h1>
            )}
            <div className="content_logo">
              {logo_list.map((val, index) => (
                <div key={index} className={`logo_list about_4_${index}`}>
                  {CSSTrans(
                    this.state.about_4_show,
                    `logo_box_${index} fadeInLeft`,
                    <div className="logo_bg" />
                  )}
                  {CSSTrans(
                    this.state.about_4_show,
                    `logo_4_${index} fadeInLeft`,
                    <img
                      className="logo"
                      src={require("@/assets/images/logo/" + val).default}
                      alt=""
                      style={{ width: "100px", height: "auto" }}
                    />
                  )}
                </div>
              ))}
            </div>
          </div>
        </SwiperSlide>
        <div className="navigation-container">
          <div className="swiper-button-prev"></div>
          <div className="swiper-button-next"></div>
        </div>
      </Swiper>
    );
  }
}
export default About;
